<template>
  <div>
    <div class="container-row">
      <div class="speaker-search-filter-wrap">
        <div class="speaker-search-filter">
          <input
            type="text"
            placeholder="Search Speakers"
            v-model="searchQuery"
            id="speakersearch"
          />
        </div>
      </div>
      <div class="four-col-wrap">
        <template v-for="speaker in filteredSpeakers">
          <div
            class="speaker-profile"
            v-if="
              speaker.avatar &&
                speaker.avatar != 'https://www.dmgeventsconferences.com/'
            "
            v-bind:key="speaker.id"
          >
            <div class="speaker-profile-outer">
              <div class="speaker-img">
                <img
                  v-if="speaker.avatar == null || speaker.avatar == ''"
                  src="https://www.futureenergyasia.com/media/7674/speaker-default.jpg?width=224&height=224&mode=crop"
                  alt=""
                />
                <img
                  class="img-fluid"
                  v-else
                  :srcset="speaker.avatar + '?width=224&height=224&mode=crop'"
                />
              </div>
              <div class="desc">
                <h6>{{ speaker.name }}</h6>
                <p>
                  {{ speaker.jobTitle }}
                </p>
                <p class="company">{{ speaker.company }}</p>
              </div>
            </div>
            <router-link
              :to="{
                name: 'SpeakerDetails',
                query: { userId: speaker.apiId },
                hash: '#top',
              }"
              v-slot="{ href, navigate }"
            >
              <div class="desc-btn">
                <div class="btn-primary">
                  <a :href="href" @click="navigate" target="_blank">View profile</a>
                </div>
              </div>
            </router-link>
          </div>
        </template>
      </div>
    </div>

    <div class="speaker-container clearfix">
      <div
        class="speaker-pop"
        v-for="speaker in speakerList"
        v-bind:key="speaker.id"
      >
        <router-link
          :to="{
            name: 'SpeakerDetails',
            query: { userId: speaker.apiId },
            hash: '#top',
          }"
        >
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import url from "./../../config/url";
export default {
  name: "ExhibitorList",
  data() {
    return {
      speakerList: [],
      searchQuery: "",
    };
  },
  computed: {
    filteredSpeakers() {
      return this.speakerList.filter((speaker) =>
        speaker.name.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
  },
  mounted() {
    //debugger
    const url = window.location.href;
    const domain = url.split("/")[2];
    console.log(domain);
    if (domain === "www.futureenergyasia.com") {
      this.eventname = "fma";
    } else if (domain === "www.future-mobility.asia") {
      this.eventname = "fma";
    } else if (domain === "www.japanenergyevent.com") {
      this.eventname = "japan";
    } else if (domain === "www.gastechevent.com") {
      this.eventname = "gastech";
    } else {
      this.eventname = "gastech";
    }
    const pathname = window.location.pathname;
    if (pathname.includes("strategic")) {
      this.type = "Strategic";
    } else if (pathname.includes("technical")) {
      this.type = "Technical";
    } else {
      this.type = "";
    }
    this.getAllSpeakerList(this.eventname, this.type);
  },
  methods: {
    getAllSpeakerList(eventname, type) {
      axios
        .get(url.category_list_api(eventname, type))
        .then((response) => {
          // Sort the speaker list by name in alphabetical order
          if (type === "Technical") {
            response.data.sort((a, b) => a.name.localeCompare(b.name));
          }
          this.speakerList = response.data;
        })
        .catch((err) => {
          console.log(err.response);
        });
    },
  },
};
</script>
<style>
#options .option-combo ul {
  margin: 0;
  display: inline-block;
  width: calc(100% - 200px);
}

img.filter-block-logo {
  max-width: 150px;
  width: 100%;
}

.subject-outer p {
  font-size: 15px;
}

.wrap-programme {
  padding: 40px 0 0;
}

.date-filter-block {
  display: flex;
  align-items: center;
}

.sub-sp-block {
  width: 80%;
}

@media (max-width: 1199px) {
  .date-filter-block {
    display: block;
  }

  img.filter-block-logo {
    display: block;
    margin: 0 auto 20px !important;
    max-width: 200px;
  }

  #options .option-combo ul {
    width: 100%;
  }

  .active {
    display: block;
  }
}
</style>
